import AdminCityPostsSection from '../../components/admin/AdminCityPostsSection'
import AdminHeader from '../../components/admin/AdminHeader'

export default function CityPostsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AdminCityPostsSection />
        </div>
      </div>
    </div>
  )
}
